module.exports = __webpack_public_path__ + "img/edit.8d880187.svg";